// The language picked by hand, read by the server on the root page (LocaleChoice::COOKIE).
export function rememberLocale(locale) {
  document.cookie = `oremus.locale=${locale}; path=/; max-age=31536000; samesite=lax`;
}
